import { Box, Button, CardContent, FormControlLabel, IconButton, TextField, Card, Typography, Grid, useMediaQuery } from "@mui/material";
import { AgModal } from "../mui-components/AgModal";
import { aguserStore, configStore, loginStore } from "../state/CommonState";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Visibility, VisibilityOff } from "@mui/icons-material";


// import { EntityCreation } from "./entityCreation";
import { PageLayout } from "../mui-components/Pagelayout";
import LabeledTextField from "../mui-components/LabeledTextField";
import Api from "../state/Api";
import AguserApi from "../state/AguserApi";
import stateList from "../static-data/states";
import { AgMuiSelect2 } from "../mui-components/Controlled";
import { ServerLists } from "../StaticData";

export function SignUp({callback}){
    const isDesktop = useMediaQuery('(min-width:769px)')
    const signupForm = useForm({
        defaultValues:{
            firstName:"",
            lastName : "",
            email:"",
            phone:"",
            password : "",
            confirmPassword : "",
            country : "",
            gst : ""
        }
    })

    const [show,showPassword] = useState(false)
    const [showConfirm,showConfirmPassword] = useState(false)
    const {register,handleSubmit,watch,formState,getValues,reset,control} = signupForm;
    const password = watch('password', '');
    const {errors} = formState;
    const [showGst,setShowGst] = useState(false);
    const email = watch("email");

    useEffect(()=>{
        if(email.match(/^(?!.*@agraga\.com)(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)){
            setShowGst(true)
        }else{
            setShowGst(false);
        }
    },[email])


    const submit = async(data)=>{
        console.log("The sign up data ",data);
        let response;
        try{
            const chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
            const passwordLength = 12;
            let password = "";
            for (var i = 0; i <= passwordLength; i++) {
                var randomNumber = Math.floor(Math.random() * chars.length);
                password += chars.substring(randomNumber, randomNumber + 1);
            }
           aguserStore.aguserRec.email = data.email.trim();
           aguserStore.aguserRec.firstName = data.firstName;
           aguserStore.aguserRec.lastName = data.lastName;
           aguserStore.aguserRec.password = password;
           aguserStore.aguserRec.phone = data.phone;
           aguserStore.aguserRec.country = data.country;
           aguserStore.aguserRec.gst = data.gst;
           aguserStore.aguserRec.status = "NEWREG";
           aguserStore.aguserRec.role = "CLIENT ADMIN";
         AguserApi.registerNewUser(
           (user)=>{
            loginStore.email = user.email;
            callback('login');  
            configStore.setModalMessage("Your Account successfully created. Please check your E-Mail.");
           }
         )

        //   AguserApi.registerNewUserV2({email:data.email,firstName:data.firstName,lastName:data.lastName,password:data.password,country:"India",phone:data.phone,status:"NEWREG",role:"CLIENT ADMIN"},(data)=>{
        //      reset();
        //      loginStore.email = data.email;
        //      callback('entity');
        //     //  configStore.setModalMessage("Your Account successfully created. Please check your E-Mail.")
        //   });
           
        //    return <EntityCreation isNewUser={true}/>;
        }catch(e){ 
           if(e.code==="ERR_NETWORK"){
            configStore.setModalMessage("Something went wrong");
            return ;
           }

           if(e.response?.status === 401 && e.response?.data?.error !== "Invalid Token" ){
            console.log("The erroror in signup is ", e.response?.data?.error)
            configStore.setModalMessage(e.response.data.error);
            return ;
         }
        }
    }

    return<Box sx={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"start",minHeight:"100%",backgroundColor:"white",padding:"10px 20% 10px 15%"}}>
            {/* <AgModal/> */}
        <form noValidate style={{width:"100%",display:"flex", justifyContent:"start",alignItems:"start",flexDirection:"column"}}  onSubmit={handleSubmit(submit)} >
               
           <Typography sx={{fontWeight:"bold",fontWeight:"bolder",fontSize:"1.5rem",marginBottom:"6%",color:"black", fontFamily:"Figtree",}}>Let's get you started</Typography>
            <Grid container rowSpacing={2} columnSpacing={3} >
                <Grid item xs={6}>
                <LabeledTextField InputProps={{
                style:{
                    // borderRadius : 0
                }
             }} control={control} size="small" fullWidth name="firstName" rules={{required:"FirstName is required",}} label="First name*"/>
                </Grid>
                <Grid item xs={6}>
                <LabeledTextField InputProps={{
                style:{
                    // borderRadius : 0
                }
             }}  label="Last Name*" control={control} size="small" fullWidth name="lastName" rules={{required:"LastName is required"}}/>
                </Grid>
                <Grid item xs={12}>
                <LabeledTextField InputProps={{
                style:{
                    // borderRadius : 0
                }
             }}  size="small" fullWidth label="Email ID*" onKeyUp={(e)=>{
                e.target.value = e.target.value.toLowerCase();
             }} control={control} name="email" rules={{required:"Email is Required",pattern:{
                value:/^(?!.*@agraga\.com)(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message : `Invalid email address`
              }}}/>
                </Grid>
                <Grid item xs={12}>
                <LabeledTextField  InputProps={{
                style:{
                    // borderRadius : 0
                }
             }}  control={control} size="small" fullWidth label="Phone number*" name="phone" rules = {{required:"Phone Number is Required",pattern:{
                value:/^[0-9]{10}$/,
                message:`Invalid phone number`
              }}}/>
                </Grid>
                <Grid item xs={12}>
                <Typography sx={{ textAlign: "start", fontFamily: "Figtree" }}>Country *</Typography>
                <AgMuiSelect2 rules={{ required: "Country is Required" }} fontSize="14px" control={control} name="country"
                            // options={["India","Australia"]}
                            options={ServerLists.countryNameList}
                            width="100%" />
                </Grid>
                {/* <Grid item xs={12}>
                <LabeledTextField   InputProps={{
                style:{
                    // borderRadius:0
                },
                endAdornment: (
                        <IconButton size="small" onClick={()=>{
                            showPassword((prevState)=>!prevState);
                        }}>
                           { show ? <VisibilityOff/> : <Visibility/>
                                      }                        </IconButton>
        ),
      }}  type={ show ? "text" : "password"}  autoComplete="off"  size="small" fullWidth label="Password" name="password" control={control } rules={{required:"Password is Required"}}  />
          
                </Grid>
                <Grid item xs={12}>
                <LabeledTextField  control={control} InputProps={{
                    style:{
                        // borderRadius:0
                    },
                endAdornment: (
                        <IconButton size="small" onClick={()=>{
                            showConfirmPassword((prevState)=>!prevState);
                        }}>
                           { showConfirm ? <VisibilityOff/> : <Visibility/>
                                      }                        </IconButton>
        ),
      }} type={ showConfirm ? "text" : "password"}  autoComplete="off"  size="small" fullWidth label="Confirm Password"  name="confirmPassword"  rules={{required:"Confirm Password is Required",validate: (value) => value === password || 'The passwords do not match',}}  />
                </Grid> */}
              { showGst &&  <Grid item xs={12}>
                <LabeledTextField onKeyUp={(e)=>{
                    console.log("the pressed key is ",e.key)
                    if(e.key===' '){
                        e.target.value = e.target.value.replace(/\s/g, '');
                    }
                    e.target.value = e.target.value.trim();
                }} fullWidth label="GST *" name="gst" rules={{
                       pattern : {
value : /^\d{2}[A-Z]{5}[0-9]{4}[A-Z][0-9][A-Z][A-Z0-9]$/,
message : "Invalid GST format. Eg: 22AAAAA0000A1Z5 or 29ABCDE1234F1ZK"
                       },
                        required: "GST is required",
                        //     pattern:{
                        //     value : /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        //     message : "Inavlid GST Number"
                        //   }
                    }
                    } control={control} size="small" />
                </Grid>}
                <Grid item xs={12}>
                <Button type="submit" fullWidth sx={{
                    marginTop:1,
            // borderRadius:0,
                textTransform:"capitalize",
                fontWeight:"bold",
                backgroundColor:"#000000",color:"white","&:hover":{
                backgroundColor:"#000000"
              }}} >SignUp</Button> 
                </Grid>
            </Grid>
            
            
            
              
              {/* <TextField error={!!errors?.gst} helperText={errors?.gst?.message} placeholder="GST" size="small" fullWidth {...register("gst",{required:"Gst is required"})}/> */}
             <Grid item xs={12} alignSelf="center">
             <Box sx={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%",paddingTop:"5px",alignSelf:"center",gap:1}} >
             <Typography sx={{textTransform:"none",color:"gray",fontSize:"12px"}}>Already have an account?</Typography>
             <Typography onClick={()=>{
              callback('login');
          }} sx={{textTransform:"none",color:"black",fontSize:"12px",fontWeight:"bolder",textDecoration:"underline","&:hover":{cursor:'pointer'}}}>Sign-in</Typography>
           </Box>
             </Grid>  
      </form>
        </Box>
     
       {/* <AgModal/>
       <Button onClick={()=>{
           navigate("/login",{replace:true})
       }} >Login</Button>
       <Button onClick={()=>{
        configStore.setModalMessage("This is First Message")
        setTimeout(()=>{
            configStore.setModalMessage("This is Second Message")
        },2000)
       }} >Show Modal</Button>
       <Button onClick={()=>{
           configStore.setModalMessage("",[],false,["This ytfduyewbfuwebfuyew wfgwev gfhgegcb ewhgjbewjhcyewy bjcwebcewj  cbbjffhgghjbb gbvdddddddd dddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg","This ytfduyewbfuwebfuyew wfgwev gfhgegcbewhgjbewjhcyewybjcwebcewjcbbjffhgghjbb gbvdddddddddddddddd edeggggggg"]);
       }}>
         Show terms 
       </Button>
       <Button onClick={()=>{
           configStore.setModalMessage("",[],false,[],"This is The deadline")
       }}>  
        Decline Reason
       </Button>
       <Button onClick={async()=>{
          const data = await ApiService.get("https://jsonplaceholder.typicode.com/todos/1");
          console.log("this is printed after endpoint call ",data);
          configStore.setModalMessage((JSON.stringify(data)));
       }}>Api Call</Button>
       <AgMuiDialog isOpen={isOpen} handleClose={closeDialog} title="New Modal"  content="The content of the new modal" buttons={[{handler:()=>{
            console.log("The handler is executed");
        },title:"Action 1"}]}/>
         <AgMuiDialog isOpen={isOpen2} handleClose={closeDialog2} title="New Modal overlayed"  content="The content of the new modal" buttons={[{handler:()=>{
            console.log("The handler is executed");
        },title:"Action 1"}]}/>
       <Button onClick={()=>{
           openDialog();
           setTimeout(()=>{
            openDialog2();
           },2000)
       }}>New Modal</Button>
       <Network/> */}
}


export function SignUpPage({callback}){
    return <PageLayout Component={<SignUp callback={callback} />} />
}